const organizationAboutImageResizeObserver = new ResizeObserver((entries) => {
    for (let entry of entries) {
        const container = entry.target.closest(".about-image__wrapper");
        const height = entry.borderBoxSize[0].blockSize;
        container.style.paddingBottom = `${height / 2}px`;
    }
});

document.querySelectorAll(".about-image__text").forEach((element) => {
    organizationAboutImageResizeObserver.observe(element);
});
